import { Screenmode } from './screenmode'

export class LinkBox {
  constructor (settings = {}) {
    this.options = $.extend({
      selectors: {
        linkBox: '.link-box',
        orangeTeaser: '.link-box__orange-teaser',
        violetTeaser: '.link-box__violet-teaser'
      }
    },
    settings)
  }

  init () {
    const that = this
    let resizeTimer

    setTimeout(function () {
      that.setBoxHeight()
    }, 500)

    $(window)
      .resize(function () {
        clearTimeout(resizeTimer)

        resizeTimer = setTimeout(function () {
          that.setBoxHeight()
        }, 250)
      })
  }

  setBoxHeight () {
    const that = this
    const currentBreakpoint = new Screenmode().getCurrentBreakpoint()
    const orangeTeaser = $(that.options.selectors.orangeTeaser)
    const violetTeaser = $(that.options.selectors.violetTeaser)

    orangeTeaser
      .css('min-height', '')

    violetTeaser
      .css('min-height', '')

    if (currentBreakpoint === 'lg' || currentBreakpoint === 'xl') {
      orangeTeaser
        .each(function () {
          const element = $(this)
          const linkBox = element.closest(that.options.selectors.linkBox)
          const violetTeaser = linkBox.find(that.options.selectors.violetTeaser)

          if (violetTeaser.length > 0) {
            if (violetTeaser.height() > element.height()) {
              element.css('min-height', violetTeaser.outerHeight() + 'px')
            } else {
              violetTeaser.css('min-height', element.outerHeight() + 'px')
            }
          }
        })
    }
  }
}

export default LinkBox
